import * as MailGroupList from './list';
import * as MailGroupForm from './form';
import * as InternalUsers from './internalUsers';
import * as ExternalUsers from './externalUsers';

const reducers = {
  ...MailGroupList,
  ...InternalUsers,
  ...MailGroupForm,
  ...ExternalUsers,
};

export default reducers;
